import React from "react";
import { List } from "../modules/Settings/Subcategories";

export function SubCategoryListPage(props) {
  return <List {...props} />;
}
